// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/checkbox/style/index.less
// module id = 1022
// module chunks = 1